
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Tag } from '@warrenbrasil/nebraska-web';
import {
  EGlobalTransactionMovement,
  GlobalTransaction
} from '@/modules/common/services/graphql/server/server.sdk';

@Component({
  components: {
    Tag
  }
})
export default class GlobalTransactionAmount extends Vue {
  @Prop({ type: Object, required: true })
  public transaction!: GlobalTransaction;

  private get computedClass() {
    switch (this.transaction.movement!.value) {
      case EGlobalTransactionMovement.Input:
        return 'global-transaction-amount--in';
      case EGlobalTransactionMovement.Output:
        return 'global-transaction-amount--out';
      case EGlobalTransactionMovement.Canceled:
        return 'global-transaction-amount--canceled';
      default:
        return null;
    }
  }
}
